import React, { useMemo, useState } from "react";
import * as Icons from "react-feather";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';
import { formatDate } from "../../shared/CommonFunctions";
import { logAuditEvent } from '../../utils/auditLogger';

function PurchaseRegisterGrid({ purchaseRegisters = [], onView, onEdit, onAdd, onDelete, UserPermissions = {}, moduleName = 'Purchase Register' }) {
  const [filterText, setFilterText] = useState("");

  const rows = useMemo(() => {
    const term = filterText.toLowerCase();
    return (purchaseRegisters || []).filter((item) => {
      return (
        (item.DealerName && item.DealerName.toLowerCase().includes(term)) ||
        (item.PurchaseFor && item.PurchaseFor.toLowerCase().includes(term))
      );
    });
  }, [purchaseRegisters, filterText]);

  const columns = [
    {
      name:<div className="titlename"><span>Purchase#</span></div> ,
      selector: row => row.PurchaseNumber,
      cell: (row) => (
        <span title={row.PurchaseNumber}>{row.PurchaseNumber}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />,
      width: '170px'
    },
    {
      name:<div className="titlename"><span>Dealer Name </span></div> ,
      selector: row => row.DealerName,
      cell: (row) => (
        <span title={row.DealerName}>{row.DealerName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Purchase Date </span></div>,
      selector: row => row.PurchaseDate,
      cell: (row) => (
        <span title={formatDate(row.PurchaseDate)}>{formatDate(row.PurchaseDate)}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
  ];

  const canView = Number(UserPermissions?.ViewModule) === 1;
  const canEdit = Number(UserPermissions?.EditModule) === 1;
  const canDelete = Number(UserPermissions?.DeleteModule) === 1;

  if (canView || canEdit || canDelete) {
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {canView && (
            <Link
              className="me-2 p-2"
              to=""
              onClick={() => {
                try {
                  const details = JSON.stringify({ PurchaseRegisterId: row?.PurchaseRegisterId, DealerName: row?.DealerName });
                  logAuditEvent(moduleName, 'View Button Click', details);
                } catch (e) {}
                onView && onView(row);
              }}
            >
              <Icons.Eye data-feather="eye" className="action-eye" />
            </Link>
          )}
          {canEdit && (
            <Link
              className="me-2 p-2"
              to=""
              onClick={() => {
                try {
                  const details = JSON.stringify({ PurchaseRegisterId: row?.PurchaseRegisterId, DealerName: row?.DealerName });
                  logAuditEvent(moduleName, 'Edit Button Click', details);
                } catch (e) {}
                onEdit && onEdit(row);
              }}
            >
              <Icons.Edit data-feather="edit" className="feather-edit" />
            </Link>
          )}
          {canDelete && (
            <Link
              className="confirm-text p-2"
              to=""
              onClick={(e) => {
                e.preventDefault();
                try {
                  const details = JSON.stringify({ PurchaseRegisterId: row?.PurchaseRegisterId, DealerName: row?.DealerName });
                  logAuditEvent(moduleName, 'Delete Button Click', details);
                } catch (e) {}
                onDelete && onDelete(row);
              }}
            >
              <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
            </Link>
          )}
        </div>
      ),
      center: "true",
      width: "150px"
    });
  }

  return (
    <>
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="DealerName"
            sortIcon={<SortArrow/>}
            persistTableHead={true}
          />
        </div>
      </div>
    </>
  );
}

export default PurchaseRegisterGrid;
